import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CrudButtons from "./components/CrudButtons";
import CustomerRefundForm from "./components/Form/CustomerRefundForm";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Button } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import notification from "../../utils/notification";
import "../../screens/Product/product.css";
import "../Style/style.css";
import { deleteCustomerRefundHeader, getOneCustomerRefundHeader } from "../../redux/actions/customerRefundHeader.action";
import {TabTitle} from "../../utils/GeneralFunction";
import { getRights } from "../../redux/actions/userRights.action";
import { useLayoutEffect } from "react";
import moment from "moment";
import { getTransationLock } from "../../redux/actions/transactionLock.action";


export default function CustomerPayment({ token }) {
	TabTitle("Customer Refund")
	const [companyId, setCompanyId] = useState(ReadCookie("defaultCompany"));
	const { log, customerRefundHeader } = useSelector((state) => state);
	const queryParams = new URLSearchParams(window.location.search);
	const [formState, setFormState] = useState("view");
	const dCompanyId = ReadCookie("defaultCompany");
	const [minimize, setMinimize] = useState(false);
	const [disable, setDisable] = useState(false);
	const [submit, setSubmit] = useState(false);
	const [flag, setFlag] = useState(false);
	const mode = queryParams.get("mode");
	const dispatch = useDispatch();
	const history = useHistory();
	const { id } = useParams();
	const [userRights, setUserRights] = useState({})
	const [menuId, setMenuId] = useState(870);

	const [transactionLock, setTransactionLock] = useState(false)

	const filterReset = () => {
		setFormState("view");
	};

	const handleDelete = () => {
		dispatch(deleteCustomerRefundHeader(token, id)).then((res) => {
			if (res.type === "DELETE_CUSTOMER_REFUND_HEADER_SUCCESS") {
				notification("success", "Customer Refund Deleted", res.payload);
				setFlag(true);
				history.push("/customer-refund/list");
			}
		});
	};

	const changeState = () => {
		setFormState("formView");
	}

	const formSave = () => {
		setSubmit(true);
	};

	useEffect(() => {
		if (mode === "add") {
			setFormState("add");
		}
	}, [mode]);

	useLayoutEffect(() => {
		dispatch(getRights(token, menuId)).then((res) => {
		  
		  if (res.type === "GET_USER_RIGHTS_SUCCESS") {
			setUserRights(res?.payload)
		  }
		});
	  }, [token])

	useEffect(() => {
		if (id) {
			setFormState("formView");
			dispatch(getOneCustomerRefundHeader(token, id)).then((res) => {
				if (res?.type === "GET_ONE_CUSTOMER_REFUND_HEADER_SUCCESS") {
					if (res?.payload?.data[0]?.refund_date) {
						let transaction_date = moment(res?.payload.data[0]?.refund_date).format("YYYY-MM-DD");
						dispatch(getTransationLock(token, transaction_date)).then((r) => {
						
							if (r.payload.data.length > 0) {
								setTransactionLock(true);
							}
						});
					}
				}
			});
		}
	}, [id]);
	
	return (
		<>
			<div className="styleContainer">
				<div className="styleBody h-100">
					<PageHeader title={"Customer Refund"} minimize={setMinimize} check={minimize} />
					<div className="bodyStyle">
						<div className="crudDiv">
							<CrudButtons
								id={id}
								name={"saleOrder"}
								reset={filterReset}
								formType={formState}
								save={formSave}
								disable={disable}
								formState={setFormState}
								onDelete={handleDelete}
								customerRefundId={id}
								userRights={userRights}
								formData={customerRefundHeader?.payload?.data}
								transactionLock={transactionLock}
							/>

							<div className="mainProductContainer">
								<CustomerRefundForm
									dCompany={dCompanyId}
									defaultCompany={companyId}
									companyId={setCompanyId}
									submit={setSubmit}
									val={submit}
									formState={formState}
									changeState={changeState}
									token={token}
									checkFlag={flag}
									setFlag={setFlag}
									logs={log}
									customerRefundId={id}
									setDisable={setDisable}
									formData={customerRefundHeader?.payload?.data}

								/>
							</div>
						</div>
					</div>
				</div>
				{minimize && (
					<div className="styleFooter">
						{" "}
						<Button className="minimize-button-style" onClick={() => setMinimize(false)}>
							{" "}
							Customer Refund{" "}
						</Button>{" "}
					</div>
				)}
			</div>
		</>
	);
}
